<script>
    import ElementMediaInput from '../../Element/Media/ElementMediaInput.svelte';

    export let data = '';
    export let onChange = () => {};
    export let onRemove = () => {};
    export let row = null;
    export let id = 'mediaInputColumn';
    export let key = '';
    export let allowRemove = true;
    export let useMarkUp = false;
    export let useMediaLibrary = false;
    export let mediaLibraryId = '';
    export let entity = null;
    export let onShowMarker = () => {};
    export let onRemoveMarkup = () => {};

    function handleColumnChange(media) {
        console.log('media changed', media)
        onChange(media, row);
    }

    function handleMediaRemove(media){
        onRemove(media, row);
    }
</script>

<ElementMediaInput
    {id}
    {key}
    bind:media={data}
    onChange={handleColumnChange}
    onRemove={handleMediaRemove}
    {allowRemove}
    {useMarkUp}
    {useMediaLibrary}
    {mediaLibraryId}
    {row}
    {entity}
    {onShowMarker}
    {onRemoveMarkup}
    />
